import React from "react"
import "./ScrollDownBtn.scss"

const ScrollDownBtn = () => {
    return (
        <div className="scroll-down-btn">
            <div className="scroll-btn-border">
                <div className="scroll-btn-arr"></div>
            </div>
            <p>Scrool Down</p>
        </div>
    )
}

export default ScrollDownBtn
